var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('treeselect',{attrs:{"multiple":_vm.multiple,"options":_vm.options || [],"placeholder":"请选择","normalizer":_vm.normalizer},on:{"input":_vm.getValue},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }